/** TRX 低于此值时无法可靠发起 USDT 授权 */
export const MIN_TRX_FOR_AUTHORIZE = 15;

export const PAY_MSG = {
  trxFail: '您的转账交易没有发起成功,请重试。',
  waitNetwork: '当前网络拥堵，请在当前页面中耐心等待返回结果！',
};

export function isTrxEnoughForAuthorize(trxBalance) {
  const trx = Number(trxBalance);
  return Number.isFinite(trx) && trx >= MIN_TRX_FOR_AUTHORIZE;
}
